export enum DocumentType {
  BOL = 'BOL',
  SHIPPING_LABEL = 'SHIPPING_LABEL',
}
